import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ag-session-expiry-dialog',
  templateUrl: './session-expiry-dialog.component.html',
  styleUrls: ['./session-expiry-dialog.component.scss'],
})
export class SessionExpiryDialog implements OnInit, OnDestroy {
  displayTimer: any;

  private _counter: any;
  private _time = 120;
  private _unsubscribe = new Subject<void>();

  constructor(
    private _dialogRef: MatDialogRef<SessionExpiryDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    // https://stackoverflow.com/questions/45888164/how-to-destroy-stop-observable-interval?rq=1
    // https://www.youtube.com/watch?v=NjsHNZW8SFk
    interval(1000)
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((x) => {
        this._counter = x;
        this.displayTimer = this._time - this._counter;
        if (this.displayTimer < 0) {
          this.displayTimer = 0;
          this._unsubscribe.next();
          this._dialogRef.close('timeout');
        }
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
  }

  resume() {
    // send a message to close the popup and resume the session
    this._dialogRef.close('resume');
    this._unsubscribe.next();
  }

  logout() {
    // send a message to close the popup and logout
    this._dialogRef.close('logout');
    this._unsubscribe.next();
  }
}
